import { createApp } from 'vue'
import { createRouter } from './common/routes/routes'
import App from './App.vue'
import { createPinia } from 'pinia'
import { useGlobalStore } from './common/stores/global'

import { translate } from './common/modules/translations'
import lazyLoad from '@/common/directives/LazyDirective.js'
// import { micon, getIcon, getMaterialIcon } from './common/modules/helpers'

const el = document.getElementById('app')
const app = createApp(App)

app.directive('lazy', lazyLoad)


// Pinia
const pinia = createPinia()
app.use(pinia)

// Store
const context = JSON.parse(document.getElementById('vue-context').textContent)
const store = useGlobalStore()
store.init(context)

// Helpers
app.config.globalProperties.__ = translate
// app.config.globalProperties.formatDate = formatDate

async function initApp() {
    // await userStore.fetchUser()
    const router = createRouter()

    app.use(router)
    app.mount(el)
}

initApp()

// import { useUserStore } from './common/stores/user'
// import { formatDate, formatAddress, jsonOrString, getColor, jsonContentBlock, formatBytes } from './common/modules/formatting'


// directives
// import DraggableDirective from '@/common/directives/DraggableDirective.js'
// import lazyLoad from '@/common/directives/LazyDirective.js'

// // global base components
// import OverviewBase from '@/common/views/OverviewBase.vue'

// // global components
// import AppNav from '@/common/components/AppNav.vue'
// import Avatar from '@/common/components/Avatar.vue'
// import AppHeader from '@/common/components/AppHeader.vue'
// import AppTopbar from '@/common/components/AppTopbar.vue'
// import AppFooter from '@/common/components/AppFooter.vue'
// import AppDock from '@/common/components/AppDock.vue'
// import AppLib from '@/common/components/AppLib.vue'
// import AdminBadge from '@/common/components/AdminBadge.vue'

// // ui components
// import UiButton from '@/common/components/ui/UiButton.vue'
// import UiButtonOptions from '@/common/components/ui/UiButtonOptions.vue'
// import UiBigButton from '@/common/components/ui/UiBigButton.vue'
// import UiSearchField from '@/common/components/ui/UiSearchField.vue'
// import UiConfirmDialog from '@/common/components/ui/UiConfirmDialog.vue'
// import UiDropzone from '@/common/components/ui/UiDropzone.vue'
// import UiToggle from '@/common/components/ui/UiToggle.vue'
// import UiTable from '@/common/components/ui/UiTable.vue'
// import UiTableCellState from '@/common/components/ui/UiTableCellState.vue'
// import UiTableCellProgress from '@/common/components/ui/UiTableCellProgress.vue'

// // form elements
// import Toggle from '@/common/components/ui/form/Toggle.vue'
// import IndexedSlider from '@/common/components/ui/form/IndexedSlider.vue'
// import InputField from '@/common/components/ui/form/InputField.vue'
// import InputTags from '@/common/components/ui/form/InputTags.vue'
// import InputSearch from '@/common/components/ui/form/InputSearch.vue'
// import InputDatetime from '@/common/components/ui/form/InputDatetime.vue'
// import InputCheckbox from '@/common/components/ui/form/InputCheckbox.vue'
// import InputTextarea from '@/common/components/ui/form/InputTextarea.vue'
// import InputSelectTeam from '@/common/components/ui/form/InputSelectTeam.vue'
// import InputCheckboxGroup from '@/common/components/ui/form/InputCheckboxGroup.vue'
// import InputRadio from '@/common/components/ui/form/InputRadio.vue'
// import InputFileUpload from '@/common/components/ui/form/InputFileUpload.vue'
// import InputFileDragDropUpload from '@/common/components/ui/form/InputFileDragDropUpload.vue'
// import InputFileDragDropUploadZone from '@/common/components/ui/form/InputFileDragDropUploadZone.vue'
// import InputImageDragDropUpload from '@/common/components/ui/form/InputImageDragDropUpload.vue'
// import InputRich from '@/common/components/ui/form/InputRich.vue'
// import InputRicher from '@/common/components/ui/form/InputRicher.vue'

// // misc
// import UiLoader from '@/common/components/ui/UiLoader.vue'
// import NoContent from '@/common/components/ui/NoContent.vue'

// const context = JSON.parse(document.getElementById('vue-context').textContent)

// const pinia = createPinia()
// app.use(pinia)

// const store = useGlobalStore()
// store.init(context)

// // Register global helpers
// app.config.globalProperties.gc = getColor
// app.config.globalProperties.getIcon = getIcon
// app.config.globalProperties.micon = micon
// app.config.globalProperties.getMaterialIcon = getMaterialIcon
// app.config.globalProperties.formatAddress = formatAddress
// app.config.globalProperties.formatBytes = formatBytes
// app.config.globalProperties.jsonOrString = jsonOrString
// app.config.globalProperties.jsonContentBlock = jsonContentBlock
// // app.config.globalProperties.isAdmin = isAdmin
// // app.config.globalProperties.role = role
// // app.config.globalProperties.isAdmin = isAdmin


// register global components
// app.component('OverviewBase', OverviewBase)
// app.component('AppNav', AppNav)

// app.directive('lazy', lazyLoad)

// const userStore = useUserStore()
